import api from './public-api';

export default api;
